import { polygonAreaM2 } from "./samplingDesign";

// Square meters in an acre. The zone editor has always divided by this number for the
// cell-sum acreage, so the accuracy tail and the pricing readout stay on the same figure.
const M2_PER_ACRE = 4046.86;

export function acresOfGeoms(geoms: readonly unknown[]): number {
  return geoms.reduce<number>(
    (sum, geom) => sum + polygonAreaM2(geom) / M2_PER_ACRE,
    0,
  );
}
